import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CssBaseline from '@material-ui/core/CssBaseline';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Done from '@material-ui/icons/Done';
import { withStyles } from '@material-ui/styles';
import * as CommonUtils from "../util/CommonUtils";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import { getClients } from "../util/ApiUtils";
import Button from "@material-ui/core/Button";
import {NotificationManager} from "react-notifications";
import { t } from '../i18n';

const classes = (theme => ({
    paper: {
        marginTop: theme.spacing(1),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
}));

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            client: null
        };
        this.chooseClient = this.chooseClient.bind(this);
        this.getClients = this.getClients.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);
    }

    componentDidMount() {
        this.getClients();
    }

    handleTextChange({ target }) {
        this.setState({
            ...this.state, [target.name]: target.value
        });
    }

    getClients() {
        this.setState({
            isLoading: true
        });
        getClients()
            .then(response => {
                console.log('response clients', response);
                this.setState({
                    clients: response,
                    isLoading: false
                });
            }).catch(error => {
            console.log('error', error);
            this.setState({
                isLoading: false
            });
        });
    }

    chooseClient() {
        console.log('binding client', this.state.client);
                let boundUserId = this.state.client;
                if (!boundUserId) {
                    NotificationManager.warning(t('app.notifications.error'), t('messages.selectClient'), 5000);
                } else {
                    localStorage.setItem("boundUserId", boundUserId);
                    if (this.state.clients) {
                        this.state.clients.forEach(function (item) {
                            if (item.id === boundUserId) {
                                localStorage.setItem("boundUserName", item.name);
                            }
                        });
                    }
                    this.setState({
                        isLoading: false,
                    }, () => {
                        NotificationManager.success(t('app.notifications.success'), t('messages.clientBound'), 5000);
                        window.location = "/";
                    });
                }

        /*
        this.setState({
            isLoading: true
        });

        bindUser(this.state.client)
            .then(response => {
                console.log("user after binding", response)
                this.setState({
                    currentUser: response,
                    isAuthenticated: true,
                    isLoading: false
                });
            }).catch(error => {
            this.setState({
                isLoading: false
            });
        });*/
    }

    render() {
        const { classes } = this.props;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
         if (this.state.isLoading) {
            return null;
        }
        return (
            <div>
                <Container component="main" maxWidth="md">
                    <CssBaseline />
                    <div className={classes.paper}>
                        <Typography>
                            <img src="/images/logo.jpg" alt={ t('home.logoAlt') }/>
                        </Typography>
                        <Box m={2} p={-2}/>
                        <Typography variant="h5" paragraph>
                            { t('home.welcome') }
                        </Typography>
                            { (isAuditor && !localStorage.getItem("boundUserId")) ?
                                <Typography paragraph variant="body1">
                                    <FormControl className={classes.formControl} style={{ width: '600px'}}>
                                        <InputLabel id="client-label">{ t('home.selectClientLabel') }</InputLabel>
                                        <Select
                                            labelId="client-label"
                                            id="client"
                                            value={this.state.client }
                                            name="client"
                                            onChange={this.handleTextChange}
                                        >
                                            {this.state.clients && this.state.clients.map(function(item) {
                                                console.log('item', item);
                                                return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
                                            })}
                                        </Select>
                                    </FormControl>
                                    <div className="col-md-6 pull-right" style={{ paddingTop: "20px", width: '600px'}}>
                                        <Button
                                            type="submit"
                                            fullWidth
                                            variant="contained"
                                            color="primary"
                                            onClick={() => this.chooseClient()}
                                        >
                                            { t('home.selectClientButton') }
                                        </Button>
                                    </div>
                                </Typography>
                                :
                                <React.Fragment>
                                    <Typography paragraph variant="body1">
                                        { t('home.description') }
                                    </Typography>
                                    <Typography>
                                        { t('home.specialFeaturesHeading') }
                                    </Typography>
                                    <List>
                                    {t('home.features').map(function(item) {
                                        return <ListItem key={item} style={{padding: '0px'}}>
                                             <ListItemIcon><Done htmlColor="#008000"/></ListItemIcon>
                                             <ListItemText primary={item}/>
                                         </ListItem>;
                                     })}
                                     </List>
                                 </React.Fragment>
                             }
                     </div>
                 </Container>
             </div>
         );
     }
 }

 Home.propTypes = {
     currentUser: PropTypes.object,
     classes: PropTypes.object.isRequired,
 };

 export default withStyles(classes)(Home);
